export const rankingBigViewBreakpoint = "1192px";
export const rankingBigViewBreakpoint = "1192px";
